import { asKeyedRoutes } from '../utils/asKeyedRoutes';

export const checkOutRoutes = asKeyedRoutes({});
